import { Grid } from "@mui/material";
import { Navigation } from "app/components";
import { MdSearch } from "react-icons/md";
import { Outlet } from "react-router-dom";

const links = [
  {
    to: "search",
    icon: <MdSearch />,
    label: "Buscar",
  },
];

export function SolicitudesLayout() {
  return (
    <Grid container className="animate__animated animate__fadeIn">
      {/* <Grid
        item
        xs={12}
        lg={2}
        sx={{
          borderRight: "1px solid #e6e6e6",
          backgroundColor: "white",
        }}
      >
        <Navigation links={links} />
      </Grid> */}

      <Grid item xs={12} lg={12} minHeight="100vh">
        <Outlet />
      </Grid>
    </Grid>
  );
}
